import DOMPurify from 'dompurify';

import { normalizeLinkUrl } from './normalize-link-url';

// Isolated DOMPurify instance so the anchor hook below only affects news
// content rendering and never the global DOMPurify singleton.
const purifier = DOMPurify(window);

// Repair links in stored content: bare hrefs (e.g. `google.com`) get a scheme
// so they aren't treated as relative paths, and external links open in a new
// tab. `target` is re-added here because it isn't in DOMPurify's default
// attribute allowlist and would otherwise be stripped.
purifier.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('href')) {
    node.setAttribute('href', normalizeLinkUrl(node.getAttribute('href') ?? ''));
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export function sanitizeNewsContent(html: string): string {
  return purifier.sanitize(html, { ADD_ATTR: ['target'] });
}
